import { helper } from '@ember/component/helper';
import config from 'embroil/config/environment';

interface TwitchEmbedOptions {
  videoId?: string;
  channel?: string;
  time?: string;
  autoplay?: boolean;
  muted?: boolean;
}

/**
 * Helper to generate Twitch embed URLs with proper parent parameter
 * 
 * Usage in templates:
 * {{twitch-embed-url videoId="v417077870" time="03h15m50s"}}
 * {{twitch-embed-url channel="somechannel"}}
 */
function twitchEmbedUrl([options]: [TwitchEmbedOptions]): string {
  const parentDomain = config.twitchParentUrl || 'localhost';
  const { videoId, channel, time, autoplay = false, muted = true } = options;

  const params = new URLSearchParams({
    parent: parentDomain,
    autoplay: String(autoplay),
    muted: String(muted),
  });

  if (videoId) {
    params.set('video', videoId);
    if (time) {
      params.set('t', time);
    }
  } else if (channel) {
    params.set('channel', channel);
  } else {
    throw new Error('Either videoId or channel must be provided to twitch-embed-url helper');
  }

  return `https://player.twitch.tv/?${params.toString()}`;
}

export default helper(twitchEmbedUrl);